<div class="button {{ type }} {{ size }}" (click)="onClick()">
    {{ text }}
</div>